var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('view.component.contacts.list.sidebarAutotopup.header'))}}),_c('div',{staticClass:"msg"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('view.component.contacts.list.sidebarAutotopup.text'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }